import { Controller } from "@hotwired/stimulus"

// Manages the "add new item" button and inline form visibility
// Used for absence types (leave types, sick leave types) settings page and the measurement sheet cards.
// Every target is optional: an empty state carries its own button (no addButton), and a read-only
// card renders none of them.
export default class extends Controller {
  static targets = ["addButton", "formContainer", "emptyState"]
  static values = { url: String }

  connect() {
    this.hideFormContainer()
  }

  showForm(event) {
    event.preventDefault()

    if (!this.hasFormContainerTarget) return

    // Show the form container first
    if (this.hasAddButtonTarget) this.addButtonTarget.classList.add("hidden")
    this.formContainerTarget.classList.remove("hidden")
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add("hidden")
    }

    // Get the URL from the clicked link
    const url = event.currentTarget.href

    // Find the turbo-frame and load the content
    const frame = this.formContainerTarget.querySelector("turbo-frame")
    if (frame && url) {
      frame.src = url
    }
  }

  hideForm(event) {
    if (event) event.preventDefault()
    this.hideFormContainer()
    if (!this.hasFormContainerTarget) return

    // Clear the turbo-frame content
    const frame = this.formContainerTarget.querySelector("turbo-frame")
    if (frame) {
      frame.innerHTML = ""
      frame.removeAttribute("src")
    }
  }

  hideFormContainer() {
    if (this.hasAddButtonTarget) this.addButtonTarget.classList.remove("hidden")
    if (this.hasFormContainerTarget) this.formContainerTarget.classList.add("hidden")
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.remove("hidden")
    }
  }
}
